import React from 'react';

import {Select} from '@kit';

import type {Ability} from '../../../../../generated/types';
import {useCharacter} from '../../character-context';
import {ABILITIES} from '../../model/abilities';
import {POINT_BUY_MIN, STANDARD_ARRAY} from '../../model/ability-generation';
import {abilityLabel} from '../../model/labels';
import {AbilityRow} from './ability-row';

import css from '../master.module.css';

type Props = {
	assigned: Partial<Record<Ability, number>>;
};

/** стандартный набор: каждое значение 15, 14, 13, 12, 10, 8 назначается одной характеристике */
export const StandardArray: React.FC<Props> = ({assigned}) => {
	const {update} = useCharacter();

	const assign = (ability: Ability, value: number | undefined) =>
		update((current) => {
			const previous = current.abilityGeneration;
			const nextAssigned = {...(previous?.method === 'standard' ? previous.assigned : {})};
			if (value === undefined) delete nextAssigned[ability];
			else nextAssigned[ability] = value;
			return {
				abilityGeneration: {method: 'standard', assigned: nextAssigned},
				baseAbilities: {...current.baseAbilities, [ability]: value ?? POINT_BUY_MIN},
			};
		});

	return (
		<div className={css.abilityInputs}>
			{ABILITIES.map((ability) => {
				const takenElsewhere = ABILITIES.filter((other) => other !== ability).map((other) => assigned[other]);
				const values = STANDARD_ARRAY.filter((value) => !takenElsewhere.includes(value));
				return (
					<AbilityRow key={ability} ability={ability} isEmpty={assigned[ability] === undefined}>
						<Select
							label={abilityLabel(ability)}
							items={values.map((value) => ({value, label: String(value)}))}
							value={assigned[ability] ?? null}
							placeholder="—"
							onChange={([value]) => assign(ability, value === undefined ? undefined : Number(value))}
						/>
					</AbilityRow>
				);
			})}
		</div>
	);
};
